import { SelectOptionType } from '@octano/global-ui';
import { format } from 'rut.js';

import { StudentFileResponse } from '../../../../../../../types/studentFileSectionTypes';
import { getSelectedOption } from '../../../../../../../utils/selectFormat';
import {
  parenthoodOptions,
  icfesFormatOptions,
  populationOptions,
  socioEconomicStratumOptions,
} from '../../../../../../../utils/selectOptions';
import { BaseOption } from '../../../../../../TeacherManagement/TeacherActivation/types';

interface Options {
  tenanCountry?: BaseOption;
  genders: SelectOptionType[];
  areaTypes: SelectOptionType[];
  healthInstitutions: SelectOptionType[];
  maritalStatus: SelectOptionType[];
  countries?: SelectOptionType[];
  regions?: SelectOptionType[];
  cities?: SelectOptionType[];
  communes?: SelectOptionType[];
  identificationTypes?: SelectOptionType[];
  campuses?: SelectOptionType[];
  schools?: SelectOptionType[];
}

export default function studentFileNewFormatPreviusData(
  data: StudentFileResponse,
  options: Options,
) {
  return {
    ...data.responses,
    ...formatReformada(data.responses, options),
    rut: data.student.rut ? format(data.student.rut) : undefined,
    passportCountry: options?.countries?.find(
      (c) => c.value === data.student.passport?.countryId,
    ),
    passportNumber: data.student.passport?.number,
    namesStudent: data.student.names,
    paternalSurname: data.student.paternalName,
    maternalSurname: data.student.maternalName,
    cv: data.studyPlan.code,
    studyPlan: data.studyPlan.name,
    campus: data.studyPlan.campus,
    schedule: data.studyPlan.schedule,
    entryYear: data?.postulation?.entryYear || undefined,
    officialEmail: data?.student?.account?.email,
    personalEmail: data?.student?.account?.personalEmail,
    birthday: data.student.birthday,
    country: options?.countries?.find(
      (c) => c.label.toLocaleLowerCase() === 'chile',
    ),
  };
}

const formatReformada = (
  data: StudentFileResponse['responses'],
  options: Options,
) => {
  return {
    personalInformation_identificationType: data.personalInformation_identificationType
      ? getSelectedOption(
          data.personalInformation_identificationType,
          options?.identificationTypes ?? [],
        ) ?? data.personalInformation_identificationType
      : undefined,
    personalInformation_nationality: data.personalInformation_nationality
      ? getSelectedOption(
          data.personalInformation_nationality,
          options?.countries ?? [],
        )
      : undefined,
    personalInformation_countryOfBirth: data.personalInformation_countryOfBirth
      ? getSelectedOption(
          data.personalInformation_countryOfBirth,
          options?.countries ?? [],
        )
      : undefined,
    personalInformation_maritalStatus: data.personalInformation_maritalStatus
      ? getSelectedOption(
          data.personalInformation_maritalStatus,
          options?.maritalStatus,
        )
      : undefined,
    personalInformation_gender: data.personalInformation_gender
      ? getSelectedOption(data.personalInformation_gender, options?.genders)
      : undefined,
    educationalInformation_country: data.educationalInformation_country
      ? getSelectedOption(
          data.educationalInformation_country,
          options?.countries ?? [],
        )
      : undefined,
    educationalInformation_department: data.educationalInformation_department
      ? getSelectedOption(
          data.educationalInformation_department,
          options?.regions ?? [],
        )
      : undefined,
    educationalInformation_city: data.educationalInformation_city
      ? getSelectedOption(
          data.educationalInformation_city,
          options?.cities ?? [],
        )
      : undefined,
    contactInformationDuringAcademicPeriod_country: data.contactInformationDuringAcademicPeriod_country
      ? getSelectedOption(
          data.contactInformationDuringAcademicPeriod_country,
          options?.countries ?? [],
        )
      : undefined,
    contactInformationDuringAcademicPeriod_zone: data.contactInformationDuringAcademicPeriod_zone
      ? getSelectedOption(
          data.contactInformationDuringAcademicPeriod_zone,
          options?.areaTypes ?? [],
        )
      : undefined,
    personalInformation_municipalityOfBirth: data.personalInformation_municipalityOfBirth
      ? getSelectedOption(
          data.personalInformation_municipalityOfBirth,
          options?.communes ?? [],
        )
      : undefined,
    contactInformationDuringAcademicPeriod_department: data.contactInformationDuringAcademicPeriod_department
      ? getSelectedOption(
          data.contactInformationDuringAcademicPeriod_department,
          options?.regions ?? [],
        )
      : undefined,
    contactInformationDuringAcademicPeriod_city: data.contactInformationDuringAcademicPeriod_city
      ? getSelectedOption(
          data.contactInformationDuringAcademicPeriod_city,
          options?.cities ?? [],
        )
      : undefined,
    contactInformationDuringAcademicPeriod_municipality: data.contactInformationDuringAcademicPeriod_municipality
      ? getSelectedOption(
          data.contactInformationDuringAcademicPeriod_municipality,
          options?.communes ?? [],
        )
      : undefined,
    eps_institution: data.eps_institution
      ? getSelectedOption(data.eps_institution, options?.healthInstitutions)
      : undefined,
    eps_contributorIdType: data.eps_contributorIdType
      ? getSelectedOption(
          data.eps_contributorIdType,
          options?.identificationTypes ?? [],
        )
      : undefined,
    studentCharacterization_population: data.studentCharacterization_population
      ? getSelectedOption(
          data.studentCharacterization_population,
          populationOptions,
        )
      : undefined,
    studentCharacterization_socioeconomicStratum: data.studentCharacterization_socioeconomicStratum
      ? getSelectedOption(
          data.studentCharacterization_socioeconomicStratum,
          socioEconomicStratumOptions,
        )
      : undefined,
    familyGroupData_parenthood: data.familyGroupData_parenthood
      ? getSelectedOption(data.familyGroupData_parenthood, parenthoodOptions)
      : undefined,
    icfes_format: data.icfes_format
      ? getSelectedOption(data.icfes_format, icfesFormatOptions)
      : undefined,
    icfes_country: data.icfes_country
      ? getSelectedOption(data.icfes_country, options?.countries ?? [])
      : undefined,
  };
};
